var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrepare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FCCC6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6675 15.625L16.7325 16.6675C17.4075 15.7975 17.82 14.7925 17.9475 13.75H16.4325C16.3275 14.4025 16.0725 15.04 15.6675 15.625ZM12.75 17.425V18.94C13.7925 18.8125 14.805 18.4075 15.675 17.7325L14.595 16.6525C14.0325 17.0575 13.4025 17.32 12.75 17.425ZM17.9475 12.25C17.8139 11.1855 17.394 10.1772 16.7325 9.3325L15.6675 10.3975C16.0725 10.96 16.3275 11.5975 16.4325 12.25M14.6625 8.1625L11.25 4.75V7.0525C8.295 7.42 6 9.94 6 13C6 16.06 8.2875 18.58 11.25 18.9475V17.4325C9.12 17.0725 7.5 15.2275 7.5 13C7.5 10.7725 9.12 8.9275 11.25 8.5675V11.5L14.6625 8.1625Z",
    fill: "#1B2559"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepare);
export default __webpack_public_path__ + "static/media/prepare.8e08a0b7fef14856c6d7fb3db3420703.svg";
export { ForwardRef as ReactComponent };